import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import createMetadataAPIActions from '../../utils/api-metadata-actions';

const options = {
  name: 'extraWorkRequests',
  baseType: 'EXTRA_WORK_REQUESTS',
  apiEndpoint: 'extra_work_requests',
  transform: t => ({ ...t, type: 'extra_work_request' })
};

const actions = createMetadataAPIActions(options);
const operations = createMetadataAPIOperations(options);
const selectors = createMetadataAPISelectors(options);

export { operations, selectors, actions };
export default createMetadataAPIReducer(options);
